let contentCardButtonStyle = {
  borderRadius: "10px",
  background: "var(--accentSurface)",
  border: "1px solid var(--accentDim)",
  height: "40px",
};

export default contentCardButtonStyle;
